(() => {
  const PROMO_ACTIVE = true;
  const THRESHOLD_CENTS = 20000;
  const GIFT_VARIANT_ID = 48262178472106;
  const GIFT_MARKER_KEY = '_auto_gwp';
  const TOAST_ADD_MSG = 'Free gift added to your cart 🎁';
  const TOAST_REMOVE_MSG = 'Free gift removed because your cart is below $200';

  let isUpdating = false;

  function showToast(message) {
    let toast = document.getElementById('gwp-toast');
    if (!toast) {
      const style = document.createElement('style');
      style.textContent = `
        #gwp-toast {
          position: fixed; left: 50%; bottom: 24px;
          transform: translateX(-50%);
          background: #000; color: #fff;
          padding: 12px 18px; border-radius: 30px;
          z-index: 999999; font-size: 14px;
          opacity: 0; transition: opacity .2s ease;
          pointer-events: none;
        }
        #gwp-toast.show { opacity: 1; }
      `;
      document.head.appendChild(style);
      toast = document.createElement('div');
      toast.id = 'gwp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(window.gwpToastTimer);
    window.gwpToastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
  }

  async function getCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    return response.json();
  }

  function getGiftItem(cart) {
    return cart.items.find(item => Number(item.variant_id) === Number(GIFT_VARIANT_ID));
  }

  // Discounted subtotal, excluding the gift item.
  // cart.total_price already reflects ALL discounts (line-level AND
  // cart-level discount codes), so we start from it and subtract
  // the gift's own line price.
  function getSubtotalWithoutGift(cart) {
    const giftItem = getGiftItem(cart);
    const giftPrice = giftItem ? giftItem.final_line_price : 0;
    return cart.total_price - giftPrice;
  }

  async function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { [GIFT_MARKER_KEY]: 'true' },
        sections: 'cart-drawer'
      })
    });
  }

  async function removeGift(giftItem) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0,
        sections: 'cart-drawer'
      })
    });
  }

  // Prestige-native drawer refresh
  function refreshDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    getCart().then(cart => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { cart } })
      );
    }).catch(() => {});
  }

  async function syncGift() {
    if (isUpdating) return;
    if (!PROMO_ACTIVE) return;
    isUpdating = true;

    try {
      const cart = await getCart();
      const subtotalWithoutGift = getSubtotalWithoutGift(cart);
      const giftItem = getGiftItem(cart);

      if (subtotalWithoutGift >= THRESHOLD_CENTS && !giftItem) {
        const response = await addGift();
        if (response.ok) {
          showToast(TOAST_ADD_MSG);
          refreshDrawer();
        } else {
          const error = await response.json().catch(() => null);
          console.error('GWP add error:', error);
        }
      }

      if (subtotalWithoutGift < THRESHOLD_CENTS && giftItem) {
        const response = await removeGift(giftItem);
        if (response.ok) {
          showToast(TOAST_REMOVE_MSG);
          refreshDrawer();
        } else {
          const error = await response.json().catch(() => null);
          console.error('GWP remove error:', error);
        }
      }
    } catch (e) {
      console.error('GWP error:', e);
    } finally {
      isUpdating = false;
    }
  }

  function delayedSyncs() {
    setTimeout(syncGift, 500);
    setTimeout(syncGift, 1200);
    setTimeout(syncGift, 2200);
  }

  document.addEventListener('DOMContentLoaded', () => delayedSyncs());
  document.addEventListener('click', e => { if (e.target.closest('button, a, input')) delayedSyncs(); }, true);
  document.addEventListener('change', () => delayedSyncs(), true);
  document.addEventListener('submit', () => delayedSyncs(), true);

  document.documentElement.addEventListener('cart:change', delayedSyncs);
  document.documentElement.addEventListener('cart:refresh', delayedSyncs);

  const originalFetch = window.fetch;
  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);
    try {
      const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0]?.url;
      if (url && /\/cart\/(add|change|update|clear)/.test(url)) delayedSyncs();
    } catch (e) {}
    return response;
  };

  setInterval(syncGift, 5000);
})();